/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

module.exports = [{
  action: 'updateCustomerRunnerTicketHookEntriesByRootId',
  message: messages.SUCCESS_UPDATE_CUSTOMER_RUNNER_TICKET_HOOK_ENTRIES_BY_ROOT_ID,
  method: 'PATCH',
  path: '/customer/:customerId/runner-ticket-hook-entries/:rootId',
  payloadType: 'collection',
  permissionIdentity: permissionIdentities.UPDATE_CUSTOMER_RUNNER_TICKET_HOOK_ENTRY,
  requestSchema: requestSchemas.customerRunnerTicketHookEntries.updateCustomerRunnerTicketHookEntriesByRootId,
}];
